import { AppBar, Dialog, Slide, Toolbar, WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ISkillAdminViewProps } from 'src/components/SkillMain';
import { IRootState } from 'src/reducers';
import SkillScenarioFactory, {
	ISkillParam,
} from 'src/scenario/SkillScenarioFactory';
import * as Actions from '../actions/skill';
import { ISkstate } from '../reducers/skill';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import { CMItemCode, isValid } from '../utils/CMData';
import SkillDetail from './SkillDetail';
import SkillMapTable from './SkillMapTable';
import SkillTable from './SkillTable';
import { SkillTableTypes } from './SkillTable';
export enum TabRow {
	SKILL,
	SKILLMAP,
}
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		caption: {
			marginTop: -14,
		},
		detailDialog: {
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		paper: {
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			marginTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(0),
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
	});

interface IState {
	showSkillId: string;
	openSkillDetailDialog: boolean;
}

class SkillResult extends React.Component<IProps, IState> {
	protected csvDownloadFormSkill: HTMLFormElement | null;
	public constructor(props: IProps) {
		super(props);

		this.state = {
			openSkillDetailDialog: false,
			showSkillId: '',
		};
	}

	public componentDidMount() {
		const param: ISkillParam = {
			adminView: this.props.adminView,
			userAttr: this.props.userAttr,
			userId: this.props.userId,
		};
		this.props.doFetchResultSkill(this.props.token, param);
		if (isValid(CMItemCode.CM_SKILLMAP_ENABLED)) {
			this.props.doFetchResultSkillMap(this.props.token, param);
		}
	}

	public render() {
		const { classes, resultSkill, resultSkillMap } = this.props;
		const { userId, locale } = this.props.userAttr;

		return (
			<>
				<Paper className={classes.paper} id="skill">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('SkillResult_0001')}
							</Typography>
						</Grid>
						<Grid item={true}>
							<IconButton
								color="primary"
								onClick={this.downloadCsv()}
							>
								<GetAppIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('SkillResult_0002')}
							</Typography>
						</Grid>
						<Grid item={true}>
							<IconButton
								onClick={this.reloadResult(TabRow.SKILL)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('SkillResult_0003')}
							</Typography>
						</Grid>
					</Grid>
					<Skill
						skill={resultSkill}
						userId={this.props.userId}
						adminView={this.props.adminView}
						handleShowSkillDetailDialog={
							this.handleShowSkillDetailDialog
						}
					/>
				</Paper>
				{isValid(CMItemCode.CM_SKILLMAP_ENABLED) && (
					<Paper className={classes.paper} id="skillmap">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('SkillResult_0004')}
								</Typography>
							</Grid>
							<Grid item={true}>
								<IconButton
									onClick={this.reloadResult(TabRow.SKILLMAP)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('SkillResult_0003')}
								</Typography>
							</Grid>
						</Grid>
						<SkillMap
							skillMap={resultSkillMap}
							userId={this.props.userId}
							adminView={this.props.adminView}
						/>
					</Paper>
				)}
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/per/downloadResultCsv.action'
					}
					ref={form => (this.csvDownloadFormSkill = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"userId":"${userId}","locale":"${locale}","lang":"${
							i18n.language
						}","accessType":"${10}","culFlg":"${false}","careerTypeId":"${10}"}`}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.openSkillDetailDialog}
					onClose={this.handleCloseSkillDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.detailDialog,
						scrollPaper: classes.scrollPaper,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseSkillDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('SkillResult_0005')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillDetail skillId={this.state.showSkillId} />
				</Dialog>
			</>
		);
	}

	/**
	 * 表示情報取得
	 */
	protected reloadResult = (tableType: number) => () => {
		const param: ISkillParam = {
			adminView: this.props.adminView,
			userAttr: this.props.userAttr,
			userId: this.props.userId,
		};
		switch (tableType) {
			case TabRow.SKILL:
				this.props.doFetchResultSkill(this.props.token, param);
				break;
			case TabRow.SKILLMAP:
				this.props.doFetchResultSkillMap(this.props.token, param);
				break;
			default:
		}
	};

	protected downloadCsv = () => (even: any) => {
		if (this.csvDownloadFormSkill) {
			this.csvDownloadFormSkill.submit();
		}
	};

	/**
	 * スキル詳細情報画面を開く
	 * @param event スキル名のクリックイベント
	 */
	protected handleShowSkillDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const skillId = event.currentTarget.getAttribute('data-skillid');
		if (skillId) {
			this.setState({
				openSkillDetailDialog: true,
				showSkillId: skillId,
			});
		}
	};

	/**
	 * スキル詳細情報画面閉じるハンドラ
	 */
	protected handleCloseSkillDetailDialog = () => {
		this.setState({ showSkillId: '', openSkillDetailDialog: false });
	};
}

interface ISkillProps {
	skill: ISkstate<Actions.IResultSkill>;
	userId: string;
	adminView: boolean;

	handleShowSkillDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
}

const Skill: React.FC<ISkillProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};
	return (
		<div style={style}>
			<SkillTable
				data={props.skill.data}
				selectedColumns={props.skill.selectedColumns}
				type={SkillTableTypes.RESULT}
				adminView={props.adminView}
				userId={props.userId}
				handleShowSkillDetailDialog={props.handleShowSkillDetailDialog}
			/>
		</div>
	);
};

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

interface ISkillMapProps {
	skillMap: ISkstate<Actions.IResultSkillMap>;
	userId: string;
	adminView: boolean;
}

const SkillMap: React.FC<ISkillMapProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};
	return (
		<div style={style}>
			<SkillMapTable
				data={props.skillMap.data}
				selectedColumns={props.skillMap.selectedColumns}
				type={SkillTableTypes.RESULT}
				adminView={props.adminView}
				userId={props.userId}
			/>
		</div>
	);
};

const mapStateToProps = (state: IRootState) => ({
	resultSkill: state.skill.resultSkill,
	resultSkillMap: state.skill.resultSkillMap,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchResultSkill: (token: string, skillParam: ISkillParam) => {
		const s = SkillScenarioFactory.createDoFetchResultSkill(
			dispatch,
			token
		);
		return s.run(skillParam);
	},
	doFetchResultSkillMap: (token: string, skillParam: ISkillParam) => {
		const s = SkillScenarioFactory.createDoFetchResultSkillMap(
			dispatch,
			token
		);
		return s.run(skillParam);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillAdminViewProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SkillResult);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ISkillAdminViewProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/SkillResult.tsx